import { render, staticRenderFns } from "./BuyApproach.vue?vue&type=template&id=7f8267f1&scoped=true"
import script from "./BuyApproach.vue?vue&type=script&lang=js"
export * from "./BuyApproach.vue?vue&type=script&lang=js"
import style0 from "./BuyApproach.vue?vue&type=style&index=0&id=7f8267f1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8267f1",
  null
  
)

export default component.exports